var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-section',{attrs:{"theme":"green","title":"國泰產險-車險","isCarInsurance":true,"datas":_vm.highlightModify,"_fields":[
      {
        name: '保單號碼',
        key: 'ceplcno',
        width: 128,
        sortable: true,
        orderByMultiKey: ['ceplcno'],
        orderByMultiType: ['asc']
      },
      {
        name: '險種',
        key: 'cepln_nm',
        width: 98,
        sortable: true,
        orderByMultiKey: ['cepln_nm'],
        orderByMultiType: ['asc']
      },
      {
        name: '被保人',
        key: 'ceisdnm',
        width: 94,
        sortable: true,
        className: 'link text-underline',
        orderByMultiKey: ['ceisdnm'],
        orderByMultiType: ['asc']
      },
      {
        name: '有效期間',
        key: 'ceplcdt',
        width: 150,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['ceplcdt'],
        orderByMultiType: ['asc']
      },
      {
        name: '保費',
        key: 'premium',
        width: 86,
        sortable: true,
        thClassName: 'text-right',
        className: 'text-right',
        orderByMultiKey: ['premium'],
        orderByMultiType: ['asc']
      },
      {
        name: '車牌號碼',
        key: 'lic_no',
        width: 95,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['lic_no'],
        orderByMultiType: ['asc']
      },
      {
        name: '引擎號碼',
        key: 'eg_no',
        width: 131,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['eg_no'],
        orderByMultiType: ['asc']
      },
      {
        name: '車種',
        key: 'veh_name',
        width: 130,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['veh_name'],
        orderByMultiType: ['asc']
      },
      {
        name: '發照日',
        key: 'lic_date',
        width: 86,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['lic_date'],
        orderByMultiType: ['asc']
      }
    ].concat(_vm._fields),"initShow":_vm.$route.query['CathayPropertyCarInsuranceShow'] !== 'false'},on:{"toggle":function (isShow) { return _vm.$router.assignQuery({ CathayPropertyCarInsuranceShow: isShow }); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm.refresh?[_c('data-table',_vm._b({attrs:{"initSort":_vm.$route.query["CathayPropertyCarInsuranceShort"]
          ? JSON.parse(_vm.$route.query["CathayPropertyCarInsuranceShort"])
          : null},on:{"changeSort":function (sort) {
              var _obj;

              return _vm.$router.assignQuery(( _obj = {}, _obj["CathayPropertyCarInsuranceShort"] = JSON.stringify(sort), _obj ));
      }},scopedSlots:_vm._u([{key:"ceplcno",fn:function(item){return [_c('span',{class:{ 'text-blue': item.data.isKeyinBySelf }},[_vm._v(_vm._s(item.data.ceplcno))])]}},{key:"ceplcdt",fn:function(item){return [_c('div',{staticClass:"pre-formatted",domProps:{"innerHTML":_vm._s(
            _vm.buildStartEndWithTimeString(
              _vm.getROCDate(item.data.ceplcdt),
              _vm.getROCDate(item.data.celpsdt),
              item.data.ceplcdt_time,
              item.data.celpsdt_time
            )
          )}})]}},{key:"ceisdnm",fn:function(item){return [_c('span',{on:{"click":function($event){_vm.routeToCustDetail(item.data.ceisdno ,item.data.ceisdnm)}}},[_vm._v("\n          "+_vm._s(_vm._f("truncate")(item.data.ceisdnm))+"\n        ")])]}},{key:"premium",fn:function(item){return [_vm._v(_vm._s(_vm._f("numberFormat")(item.data.premium))+"元")]}},{key:"lic_date",fn:function(item){return [_vm._v(_vm._s(_vm.getROCDateCar(item.data.lic_date)))]}},{key:"action",fn:function(item){return [_c('a',{staticClass:"text-red text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.doDelete(item.data)}}},[_vm._v("刪除")])]}}])},'data-table',props,false))]:undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }